import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom'
import EventsFeed from './pages/EventsFeed/EventsFeed';
import SearchResults from "./pages/OmniSearch/SearchResults";
import NewTenderList from "./pages/TenderBlock/Tenders/New/NewTenderList";
import ActiveTenderList from "./pages/TenderBlock/Tenders/Active/ActiveTenderList";
import UnderwayTenderList from "./pages/TenderBlock/Tenders/Underway/UnderwayTenderList";
import AllTenderList from "./pages/TenderBlock/Tenders/All/AllTenderList";
import CreateTender from "./pages/TenderBlock/Tenders/CreateTender/CreateTender";
import IncomingTenderRequestList from "./pages/TenderBlock/TenderRequests/Incoming/IncomingTenderRequestList";
import AcceptedTenderRequestList from "./pages/TenderBlock/TenderRequests/Accepted/AcceptedTenderRequestList";
import UnderwayTenderRequestList from "./pages/TenderBlock/TenderRequests/Underway/UnderwayTenderRequestList";
import ArchivedTenderRequestList from "./pages/TenderBlock/TenderRequests/Archived/ArchivedTenderRequestList";
import TenderDetails from "./pages/TenderBlock/Details/TenderDetails";
import AdvertList from "./pages/Adverts/AdvertList/AdvertList";
import Contractors from "./pages/Catalogs/Contractors/Contractors";
import Users from "./pages/Catalogs/Users/Users";
import Production from "./pages/Catalogs/Products/Products";
import Companies from "./pages/Catalogs/Companies/Companies";
import Articles from "./pages/Catalogs/Articles/Articles";
import Permissions from "./pages/System/Permissions/Permissions";
import SystemOverview from "./pages/Developers/SystemOverview/SystemOverview";
import MongoDbProfiler from "./pages/Developers/MongoDbProfiler/MongoDbProfiler";
import Performance from "./pages/Developers/Performance/Performance";
import Contacts from "./pages/Contacts/Contacts";
import Partners from "./pages/Partners/Partners";
import Profile from "./pages/Profile/Profile";
import {userContext} from "./auth/Auth";
import PdfViewerModal from "./modals/PdfViewerModal";
import ActionLink from "./controls/ActionLink";
import AdvertWizard from "./pages/Adverts/CreateAdvert/AdvertWizard";
import CompanyForm from "./pages/Catalogs/Companies/CompanyForm";
import Applications from "./pages/System/Applications/Applications";
import Settings from "./pages/System/Settings/Settings";

class Routes extends Component {
    state = {
        showConditionsModal: false
    };

    render() {
        let context = userContext.get();
        let showDemoNotification = context && context.roleSystemName === 'Provider' && context.isDemo;

        return (
            <div className="px-content">
                {
                    showDemoNotification &&
                    <div className="px-block-alerts">
                        <div className="px-block-alerts-namespace--light">
                            <div className="alert alert-danger px-block-alerts-namespace--light__alert">
                                <i className="fa fa-exclamation-triangle"/> Ознакомьтесь со
                                {' '}
                                <ActionLink onClick={() => this.setState({showConditionsModal: true})}>
                                    схемой работы
                                </ActionLink>
                                {' '}
                                платформы перед началом работы
                            </div>
                        </div>
                        <PdfViewerModal documentUrl={`${window.location.origin}/documents/Схема работы.pdf`}
                                        show={this.state.showConditionsModal}
                                        onHide={() => this.setState({showConditionsModal: false})}/>
                    </div>
                }
                <Switch>
                    {/*Главная страница (лента событий)*/}
                    <Route exact path="/" component={AdvertList}/>
                    {/*Авторизация и регистрация*/}
                    {/*Результаты глобального поиска*/}
                    <Route path="/search/:query" component={SearchResults}/>
                    {/*Тендеры для оператора и клиента*/}
                    <Route exact path="/tenders/new" component={NewTenderList}/>
                    <Route exact path="/tenders/active" component={ActiveTenderList}/>
                    <Route exact path="/tenders/underway" component={UnderwayTenderList}/>
                    <Route exact path="/tenders/all" component={AllTenderList}/>
                    <Route exact path="/tenders/create" component={CreateTender}/>
                    {/*Тендеры для поставщика*/}
                    <Route exact path="/tenderRequests/incoming" component={IncomingTenderRequestList}/>
                    <Route exact path="/tenderRequests/accepted" component={AcceptedTenderRequestList}/>
                    <Route exact path="/tenderRequests/underway" component={UnderwayTenderRequestList}/>
                    <Route exact path="/tenderRequests/archived" component={ArchivedTenderRequestList}/>
                    {/*Детали тендера*/}
                    <Route path="/tenders/:tenderId" component={TenderDetails}/>
                    {/*Объявления*/}
                    <Route exact path="/adverts" component={AdvertList}/>
                    <Route exact path="/adverts/create/:type" component={AdvertWizard}/>
                    <Route exact path="/adverts/:filter" component={AdvertList}/>
                    {/*Справочники*/}
                    <Route exact path="/catalogs/contractors" component={Contractors}/>
                    <Route exact path="/catalogs/users" component={Users}/>
                    <Route exact path="/catalogs/articles" component={Articles}/>
                    <Route exact path="/catalogs/products" component={Production}/>
                    <Route exact path="/catalogs/companies" component={Companies}/>
                    <Route exact path="/catalogs/companies/create" component={CompanyForm}/>
                    <Route exact path="/catalogs/companies/edit/:companyId" component={CompanyForm}/>
                    {/*Система*/}
                    <Route exact path="/system/permissions" component={Permissions}/>
                    <Route exact path="/system/applications" component={Applications}/>
                    <Route exact path="/system/settings" component={Settings}/>
                    {/*Для разработчиков*/}
                    <Route exact path="/developer/overview" component={SystemOverview}/>
                    <Route exact path="/developer/mongodb" component={MongoDbProfiler}/>
                    <Route exact path="/developer/performance" component={Performance}/>
                    {/*Прочее*/}
                    <Route exact path="/contacts" component={Contacts}/>
                    <Route exact path="/partners" component={Partners}/>
                    {/*Профиль пользователя*/}
                    <Route exact path="/profile" component={Profile}/>
                </Switch>
            </div>
        );
    }
}

export default Routes;


// WEBPACK FOOTER //
// ./src/Routes.js